

   <h2 mat-dialog-title>
    <p *ngIf="questionID==0"> Add AI Qualification</p>
    <p *ngIf="questionID>0"> Update AI Qualification</p>
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
    
 <mat-dialog-content>
 <div class="rule-card">
  <div class="rule-title">
    <!-- Resident must not have severe alcohol (ETOH) dependence with withdrawal symptoms. -->
     <mat-form-field class="example-full-width">
      <mat-label>Title</mat-label>
      <textarea
          matInput
          maxlength="500"
          [(ngModel)]="questionTitle"
          required
          placeholder="Add title"
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="6">
        </textarea>

      <!-- <input matInput maxlength="500" [(ngModel)]="questionTitle" [required]="true" placeholder="Add title"/> -->
      <!-- <mat-error *ngIf="formDialog.get('categoryName').invalid &&
          (formDialog.get('categoryName').dirty ||
          formDialog.get('categoryName').touched)">
        <span>This field is mandatory.</span>
      </mat-error> -->
    </mat-form-field>
  </div>

  
   <div class="weight-row">
  <span class="weight-label">Weight:</span>

   <mat-slider color="primary" step="1" min="1" max="10" (input)="gridsize = $event.value" 
    [value]="gridsize" class="weight-slider">
   </mat-slider> 

   <input class="weight-field-input" type="number" [(ngModel)]="gridsize" readonly />

  </div>

  <div class="rule-divider"></div>

  <div class="bottom-row">
      <mat-checkbox color="primary" class="mandatory"
        [(ngModel)]="isMandatoryRule" (change)="onMandatoryChange($event)">
       Mandatory Rule
    </mat-checkbox>


    <div class="type-group" >
      <ng-container *ngIf="isMandatoryRule">
        <span class="type-label">Type:</span>
       <button class="pill" [class.active]="selectedType == 'PASS'"
       (click)="onTypeSelect('PASS')">
        Pass
      </button>
      <button class="pill" [class.active1]="selectedType == 'FAIL'"
        (click)="onTypeSelect('FAIL')">
        Fail
      </button>
      </ng-container>
      
      <!-- <button class="pill active">Mandatory Pass</button>
      <button class="pill active1">Mandatory Fail</button> -->
    </div>

    <mat-checkbox
        color="primary"
        class="mandatory"
        [(ngModel)]="isFollowUpFlag"
        (change)="onFollowUpFlagChange($event)">

        
        <mat-icon class="followup-icon">flag</mat-icon>
        <span class="followup-text">FollowUp</span>

      </mat-checkbox>

  </div>
   </div>

</mat-dialog-content>

 <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="closeDialog()">Cancel</button>
    <button mat-flat-button color="primary" (click)="saveAIQualification()" 
     [disabled]="!questionTitle || questionTitle.trim() === ''">
     {{text}}
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>





  

  




